import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/post/admin/posts/comment/page',
    method: 'get',
    params: query
  })
}

export function updateCommentPostBanStatus (obj) {
  return request({
    url: '/post/admin/posts/banStatus',
    method: 'put',
    data: obj
  })
}

export function getCommentPost (id) {
  return request({
    url: `/post/admin/posts/comment/${id}`,
    method: 'get',
  })
}